'use strict';

import '../../../js/vendor/select2/dist/js/select2.js';

class SelectSearch {
    ui;
    wrap;

    constructor(options) {
        if (options.wrap) {
            this.wrap = options.wrap;
        }

        if (this.wrap) {
            this.ui = {
                selects: $('.js-select-search select'),
                selectSingle: $('.js-select-search-single select'), // UMMRET-1065
                selectsRole: $('select[role="listbox"]')
            };
            this.bindUIActions();
        }
    }

    bindUIActions() {
        $(window).on('load', () => this.initializeSelects());
        $(window).on('load', () => {
            this.ui.selectsRole.each((index, select) => {
                $(select).attr('aria-selected', 'false');
            });
        });

        this.ui.selectsRole.on('click', (e) => {
            // console.log('clicked');
            // console.log(e.currentTarget);
        });

        this.ui.selects.on('select2:unselect', (e) => {
            $(e.currentTarget).data('disable-open', true);
        });

        this.ui.selects.on('select2:opening', (e) => {
            if($(e.currentTarget).data('disable-open')) {
                e.preventDefault();
            }
            $(e.currentTarget).data('disable-open', false);
        });

        // UMMRET-1065
        this.ui.selectSingle.on('select2:unselect', (e) => {
            $(e.currentTarget).data('disable-open', true);
        });

        this.ui.selectSingle.on('select2:opening', (e) => {
            if($(e.currentTarget).data('disable-open')) {
                $(e.currentTarget).data('disable-open', true);
                e.preventDefault();
            }
            $(e.currentTarget).data('disable-open', false);
        });
    }

    initializeSelects() {
        $(this.ui.selects).each((index, select) => {
            const $parent = $(select).closest('.js-select-search');

            $(select).select2({
                placeholder: $parent.data('placeholder'),
                dropdownParent: $parent,
                closeOnSelect: false, // UMMSFAD-111 leave filter panel open for multiple filter selection
                theme: 'umms'
            });

            $parent.removeClass('is-not-loaded').addClass('is-loaded');
        });

        // UMMRET-1065
        $(this.ui.selectSingle).each((index, select) => {
            const $parent = $(select).closest('.js-select-search-single');

            $(select).select2({
                // adds clear button next to selected item, only use if form does not submit on selection
                // allowClear: true,
                closeOnSelect: true,
                dropdownParent: $parent,
                minimumResultsForSearch: 'Infinity', // removes text input field from selection dropdown
                placeholder: $parent.data('placeholder'),
                theme: 'umms'
            });

            $parent.removeClass('is-not-loaded').addClass('is-loaded');
            //$(this).setAttribute('aria-label', 'SelectSpecialty');
        });

        //UMMREDESGN-1516 set aria label for select input
        if($('.site-search .select2-search__field').length) {
            const $inputField = $('.site-search .select2-search__field');
            const ariaLabel = $inputField.closest('.select-search').find('.select-search__select').attr('aria-label');

            if (ariaLabel !== '') {
                $inputField.attr('aria-label', ariaLabel);
            }
        }
    }

    refreshSelects() {
        this.ui.selects.select2('destroy');
        this.ui.selectSingle.select2('destroy'); // UMMRET-1065
        this.initializeSelects();
    }
}

export default SelectSearch;
